import a from"./_getMapData.js";var t=a;var r=function(a){return t(this,a).has(a)};export{r as default};
//# sourceMappingURL=_mapCacheHas.js.map
